import { render, staticRenderFns } from "./HeroChannels.vue?vue&type=template&id=f612a3d0&scoped=true&"
import script from "./HeroChannels.vue?vue&type=script&lang=js&"
export * from "./HeroChannels.vue?vue&type=script&lang=js&"
import style0 from "./HeroChannels.vue?vue&type=style&index=0&id=f612a3d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f612a3d0",
  null
  
)

export default component.exports